export class FormConfigurations {
    public step1: string;
    public step2: string;
    public step3: string;
    public step4: string;
    public step5: string;
    public stepAdditional: string;
    public stepHJH: string;
    public sendError: string;
    public isLoggedIn: boolean;
    public formId: string;
    public signatureUrl: string;
    public showAdditionalInformation: boolean;
    public showCreditCheck: boolean;
    public isHjhApplication: boolean;

    constructor(private container: JQuery) {
        const baseUrl = container.attr('data-api-root-prefix');
        this.step1 = baseUrl + container.attr('data-step-api-url-' + 1);
        this.step2 = baseUrl + container.attr('data-step-api-url-' + 2);
        this.step3 = baseUrl + container.attr('data-step-api-url-' + 3);
        this.step4 = baseUrl + container.attr('data-step-api-url-' + 4);
        this.step5 = baseUrl + container.attr('data-step-api-url-' + 5);
        this.stepAdditional = baseUrl + container.attr('data-step-api-url-additional');
        this.stepHJH = baseUrl + container.attr('data-step-api-url-hjh');
        this.sendError = baseUrl + container.attr('data-send-error-api-url');
        this.isLoggedIn = JSON.parse(container.attr('data-step-logged-in').toLowerCase());
        this.signatureUrl = container.attr('data-signature-url');
        this.showAdditionalInformation = JSON.parse(container.attr('data-show-additional-information').toLowerCase());
        this.showCreditCheck = JSON.parse(container.attr('data-show-credit-check').toLowerCase());
        this.isHjhApplication = JSON.parse(container.attr('data-is-hjh-application').toLowerCase());
        
        if (this.isLoggedIn) {
            this.formId = (container.attr('data-form-id'));
        }
    }
}
